export default "__VITE_ASSET__ECDG9OIX__"